import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import ProposalContextMenu from '../context-menu/ProposalContextMenu';

import { __t, applyTranslations } from 'utils/language';

import { ListContextMenu, ProposalCreatorProfile } from 'types';

applyTranslations(require('./proposal-tile-approval-footer.i18n.json'));

type Props = {
  onApprove?: () => void,
  onReject?: () => void,
  hideContextMenu?: boolean,
  creatorProfile: ProposalCreatorProfile,
  contextMenuProps?: ListContextMenu,
  canDelete?: boolean,
  onDelete?: () => void
};

const ApprovalModeFooter = (
  {
    onReject,
    onApprove,
    hideContextMenu,
    canDelete,
    onDelete,
    creatorProfile,
    contextMenuProps
  }: Props
): JSX.Element => (
  <React.Fragment>
    <ActionButton onClick={onReject}>
      {__t('proposal_tile_approval_footer.reject_profile_label')}
    </ActionButton>
    <ActionButton
      onClick={onApprove}
      color="primary"
    >
      {__t('proposal_tile_approval_footer.approve_profile_label')}
    </ActionButton>
    {!hideContextMenu && (
      <ProposalContextMenu
        canDelete={canDelete}
        onDelete={onDelete}
        creatorProfile={creatorProfile}
        contextMenuProps={contextMenuProps}
      />
    )}
  </React.Fragment>
);

export default ApprovalModeFooter;
